var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99922 17.4501C6.23922 17.4501 3.19922 14.4101 3.19922 10.6501C3.19922 6.8901 6.23922 3.8501 9.99922 3.8501C13.7592 3.8501 16.7992 6.8901 16.7992 10.6501C16.7992 14.4101 13.7592 17.4501 9.99922 17.4501ZM9.99922 4.6501C6.67922 4.6501 3.99922 7.3301 3.99922 10.6501C3.99922 13.9701 6.67922 16.6501 9.99922 16.6501C13.3192 16.6501 15.9992 13.9701 15.9992 10.6501C15.9992 7.3301 13.3192 4.6501 9.99922 4.6501Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9115 7.1709L13.4771 7.7369L7.08513 14.1289L6.51953 13.5633L12.9115 7.1709Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08513 7.1709L13.4771 13.5629L12.9115 14.1289L6.51953 7.7369L7.08513 7.1709Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconClose);
export default __webpack_public_path__ + "static/media/TH-Icon-Close.0d974ce28a96c80570b5eb5ee110d292.svg";
export { ForwardRef as ReactComponent };